import React, { Fragment } from "react";
import classnames from "classnames";
import { useDispatch } from "react-redux";
import { FormattedMessage } from "react-intl";

import { Button } from "../../../components/button/Button";
import { Icon } from "../../../components/icon/Icon";
import { Desktop, TabletMobile } from "../../../hocs/Responsive";
import { generateDeeplink } from "../../../components/deeplinkDialog/deeplinkDialog.actions";
import { useIntlTranslate } from "../../../hooks";
import { Tooltip } from "../../../components/tooltip/Tooltip";

import "./SpsonPanel.scss";

const SpsonPanelBase = ({ className, description }) => {
  const dispatch = useDispatch();
  const translate = useIntlTranslate();

  function handleGenerateLinkClick() {
    dispatch(generateDeeplink());
  }

  const panelClasses = classnames("spson-panel", className);

  return (
    <section className={panelClasses} data-testid={"spson-panel"}>
      <h2 className={"spson-panel__header"} data-testid={"spson-panel-header"}>
        <FormattedMessage id={"spson_panel_title"} />
      </h2>
      {description && (
        <div className={"spson-panel__description"}>
          <FormattedMessage id={"spson_installation_description"} />
        </div>
      )}
      <div className={"spson-panel__cta"}>
        <Button
          size={"medium"}
          onClick={handleGenerateLinkClick}
          aria-label={translate("aria_generate_link")}
        >
          <FormattedMessage id={"get_started"} />
        </Button>
        <Tooltip content={<FormattedMessage id="spson_banner_help_tooltip" />}>
          <Icon icon={"far fa-question-circle spson-panel__extra-info"} />
        </Tooltip>
      </div>
    </section>
  );
};

export const SpsonFluidPanel = ({ className }) => (
  <SpsonPanelBase className={classnames(className, "spson-panel--fluid")} />
);

export const SpsonPanel = ({ className }) => (
  <Fragment>
    <TabletMobile>
      <SpsonFluidPanel className={className} />
    </TabletMobile>
    <Desktop>
      <SpsonPanelBase
        className={classnames(className, "spson-panel--sidebar")}
        description={<FormattedMessage id={"spson_installation_description"} />}
      />
    </Desktop>
  </Fragment>
);
